var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../../../service/api.service';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
var KtsReportService = /** @class */ (function (_super) {
    __extends(KtsReportService, _super);
    function KtsReportService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        return _this;
    }
    KtsReportService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    KtsReportService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return KtsReportService;
}(ContentBaseService));
export { KtsReportService };
var ConstructionReport = /** @class */ (function () {
    function ConstructionReport() {
        this.$type = "put" /* Put */;
        this.construction_file = [];
        this.is_last_day = true;
    }
    return ConstructionReport;
}());
export { ConstructionReport };
var ConstructionFile = /** @class */ (function () {
    function ConstructionFile() {
    }
    return ConstructionFile;
}());
export { ConstructionFile };
var FileUpload = /** @class */ (function () {
    function FileUpload() {
    }
    return FileUpload;
}());
export { FileUpload };
var Msg = /** @class */ (function () {
    function Msg() {
        this.error = false;
    }
    return Msg;
}());
export { Msg };
//# sourceMappingURL=report.service.js.map